<template>
  <div>
    <div class="table-wrap">
      <el-table
        :data="pageData.list"
        style="width: 100%" height="500px">
        <el-table-column
          prop="id"
          label="编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="business_name"
          label="处理属性"
          width="100">
        </el-table-column>
        <el-table-column
          prop="node_name"
          label="步骤名"
          width="120">
        </el-table-column>
        <el-table-column
          prop="owner_user_name"
          label="拥有人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="select_action"
          label="操作"
          width="100">
        </el-table-column>
        <el-table-column
          prop="comments"
          label="意见"
          width="180">
        </el-table-column>
        <el-table-column
          prop="handle_time"
          label="处理时间"
          width="150">
          <template slot-scope="scope">
            {{scope.row.finish_time||scope.row.handle_time||scope.row.posted_time||scope.row.receive_time}}
          </template>
        </el-table-column>
        <el-table-column
          prop="user_name"
          label="实际处理人"
          width="100">
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "FlowHistoryComponents",
  props:{
    where:{
      type:Object,
      default(){
        return {};
      }
    }
  },
  data(){
    return{
      $_where:{},
      loading:true,
      pageData:{
        list:[],
        total:0,
        pageSize:100,
        page:1
      },
    }
  },
  mounted() {
    this.initData()
  },
  watch:{
    where:{
      deep:true,
      immediate:true,
      handler(){
        // this.initData()
      }
    }
  },
  methods:{
    initData(){
      this.$_where=this.where;
      this.getList();
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where=JSON.parse(JSON.stringify(that.$_where));
      Http.get("flow/FlowProcessSteps/getListSteps",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.table-wrap {
  margin-top: 5px;
  height: unset !important;
  overflow: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowHistoryComponents.vue